import React, { useEffect, useState } from "react"
import axios from 'axios'
import ListHSK5Component from "./HSK5component";
import { useLocation, Navigate } from 'react-router-dom';

export default function ListHSK5LimitsSending() {

        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);
        const id = Number(queryParams.get('id'));

        const allowedIds = new Set([...Array(92).keys()].map(x => x + 1)); // Set of numbers 1-24

        const [isPaidHSK5, setIsPaidHSK5] = useState(3)

        useEffect(() => {
         const is_paidHSK5 = async () => {
            try {
              const response = await axios.get(`${process.env.REACT_APP_BACKEND}/is_paid?hsk=${'_hsk5'}`);
              //console.log(response.data.paid);
              if (response.data.paid === 1) {
                setIsPaidHSK5(response.data.paid);
              } else if (response.data.paid === 0) {
                setIsPaidHSK5(2);
              }
            } catch (error) {
              console.error("Error fetching payment status:", error);
            }
          };
          is_paidHSK5()
        }, [])

        if (id != 1 && isPaidHSK5 === 2){
            return <Navigate to="/courses" />;
        }

        if (!allowedIds.has(id)) {
            return <Navigate to="/listHSK5" />;
        }

        const limit1 = (id - 1) * 25 + 1; // Start of the range
        const limit2 = id * 25;       

    return <ListHSK5Component limit1={limit1} limit2={limit2} />;
}